export default __webpack_public_path__ + "static/media/screw-conveyor.845a2328.jpg";